import { Text, Tooltip } from 'bold-ui'
import { DateTime } from 'components/date'
import moment from 'moment'
import React from 'react'
import { HistoricoMedicaoModel } from 'view/atendimentos/types/HistoricoMedicaoModel'

const TooltipMedicao = (props: { medicoes: HistoricoMedicaoModel; children: React.ReactElement }) => (
  <Tooltip
    text={
      props.medicoes.dataRegistro
        ? `Registrado por ${props.medicoes.nomeResponsavel} - ${moment(props.medicoes.dataRegistro).format(
            'DD/MM/YY HH:mm'
          )}`
        : 'Registrado no atendimento atual'
    }
  >
    {props.children}
  </Tooltip>
)
export const renderMedicao = (medicaoGetter: (x: HistoricoMedicaoModel) => any) => (
  medicoes: HistoricoMedicaoModel
) => (
  <TooltipMedicao medicoes={medicoes}>
    <Text component='p'>{medicaoGetter(medicoes) ?? '-'}</Text>
  </TooltipMedicao>
)

export const renderDataHoraMedicao = (medicoes: HistoricoMedicaoModel) => (
  <TooltipMedicao medicoes={medicoes}>
    <Text component='p' style={{ margin: '0.5rem 0' }}>
      <DateTime
        value={moment(medicoes.dataMedicao)}
        format={`DD/MM/YYYY ${medicoes.tipoMedicao === 'anterior' ? '' : 'HH:mm'}`}
      />
      {medicoes.tipoMedicao === 'anterior' && (
        <Text component='span' style={{ fontStyle: 'italic' }}>
          Reg. tardio
        </Text>
      )}
    </Text>
  </TooltipMedicao>
)

export const renderDataMedicao = (medicoes: HistoricoMedicaoModel) => (
  <TooltipMedicao medicoes={medicoes}>
    <Text component='p' style={{ margin: '0.5rem 0' }}>
      <DateTime value={moment(medicoes.dataMedicao)} format={`DD/MM/YYYY`} />
    </Text>
  </TooltipMedicao>
)
